'use client';

import { getCustomLoaderAnimation } from '@/lib/loaderAnimation';

import { useAppState } from './app.state.hook';

/** The publisher's custom processing animation, or `undefined` for the default spinner. */
export const useProcessingAnimationUrl = (): string | undefined => {
  const { initialBoot } = useAppState();
  return getCustomLoaderAnimation(initialBoot?.theme?.general?.loaderAnimation);
};
